module.exports = __webpack_public_path__ + "static/media/bug.dbf3fba2.svg";